import { useContext } from 'react';
import { Box, Pagination, SxProps, Theme, useMediaQuery, useTheme } from '@mui/material';

import { PaginationContext } from './context/pagination.context';

interface IProps {
  containerStyles?: SxProps<Theme>;
}

export const PaginationControl = ({ containerStyles = {} }: IProps) => {
  const theme = useTheme();
  const isTablet = useMediaQuery(theme.breakpoints.down('md'));

  const ctx = useContext(PaginationContext);
  if (!ctx) return null;

  const { count, page, rowsPerPage, setPage, isShown } = ctx;
  const totalPages = Math.ceil(count / rowsPerPage);

  if (!isShown || totalPages <= 1) return null;

  return (
    <Box id="pagination-control-component__components-pagination-buttons__box__l23"
    sx={{
      width: '100%',
      display: 'flex',
      boxSizing: 'border-box',
      px: isTablet ? '6px' : '12px',
      ...containerStyles
    }}>
      
      <Pagination id="pagination-control-component__components-pagination-buttons__pagination__l32"
      count={totalPages}
      page={page}
      size={isTablet ? 'small' : 'medium'}
      onChange={(_, value) => setPage(value)}
      color="primary"
      variant="text"
      boundaryCount={1}
      siblingCount={1}
      sx={{
        '& .MuiPaginationItem-root.Mui-selected': {
          bgcolor: theme.palette.primary.main,
          color: theme.palette.common.white,
          '&:hover': {
            bgcolor: theme.palette.primary.dark
          }
        }
      }} />
      
    </Box>);

};